/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Portal, Spacing, Text, useModal,
} from '@doveit/bricks';
import Markdown from 'react-markdown';
import TeamLeaderboardPosition, { TeamLeaderboardPositionProps } from '../team-leaderboard-position/TeamLeaderboardPosition';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import * as styles from './TeamLeaderboardPositionPreview.style';

export interface TeamLeaderboardPositionPreviewProps extends Omit<TeamLeaderboardPositionProps, 'preview' | 'previewLimit'> { }
const PREVIEW_ITEMS_LIMIT = 5;
const TeamLeaderboardPositionPreview: React.FC<TeamLeaderboardPositionPreviewProps> = (
  {
    teamLeaderboardItems,
  },
) => {
  const modal = useModal();

  const isClickable = React.useMemo(() => teamLeaderboardItems && teamLeaderboardItems.length > PREVIEW_ITEMS_LIMIT, [teamLeaderboardItems]);

  const openCompleteTeamLeaderboardModal = React.useCallback(() => {
    modal.open();
  }, [modal]);

  return (
    <>
      <div
        css={styles.rankPreview}
        $isClickable={isClickable}
        onClick={isClickable ? openCompleteTeamLeaderboardModal : undefined}
      >
        <TeamLeaderboardPosition
          teamLeaderboardItems={teamLeaderboardItems}
          preview
          previewLimit={PREVIEW_ITEMS_LIMIT}
        />
      </div>
      <Portal>
        <SimpleModal
          isOpen={modal.isOpen}
          close={modal.close}
          title="Classifica agenti team"
          aria-label="Modale per visualizzare la classifica completa degli agenti del team"
        >
          <Text.Body>
            <Markdown>
              **Classifica completa** di consulenti e agenti del tuo team
            </Markdown>
          </Text.Body>
          <Spacing margin={[0, 0, 400]} />
          <TeamLeaderboardPosition
            teamLeaderboardItems={teamLeaderboardItems}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};

export default TeamLeaderboardPositionPreview;
